import React from "react";
import SmartIcon from "./SmartIcon.tsx";
import {TiArrowSortedDown, TiArrowSortedUp} from "react-icons/ti";

interface NumericFieldArrowsProps {
  onArrowUpClick: () => void;
  onArrowDownClick: () => void;
}

const NumericFieldArrows: React.FC<NumericFieldArrowsProps> = (
  {
    onArrowUpClick,
    onArrowDownClick,
  }: NumericFieldArrowsProps) => {
  return (
    <>
      <div
        onClick={onArrowUpClick}
        className="cursor-pointer w-4 h-4 flex items-center justify-center rounded hover:bg-n-500"
      >
        <SmartIcon name={TiArrowSortedUp} className="w-4 h-4 hover:fill-n-300"/>
      </div>
      <div
        onClick={onArrowDownClick}
        className="cursor-pointer w-4 h-4 flex items-center justify-center rounded hover:bg-n-500"
      >
        <SmartIcon name={TiArrowSortedDown} className="w-4 h-4 hover:fill-n-300"/>
      </div>
    </>
  );
}

export default NumericFieldArrows;